import templateComponents from '../../../Template/config/components'
import selection from './selection'
import scorecard from './scorecard'

export default {
  ...templateComponents,
  selection,
  scorecard,
}
